import React from 'react';
import './sec2-about.css'
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';
gsap.registerPlugin(ScrollTrigger);
const Sec2about = () => {

const [about, setabout]= useState([]);
 const [content, setcontent]= useState([]);

useEffect(() => {
const getcontent = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setcontent(res.data);
}
getcontent();
}, []);




 const secRef = useRef(null);


useEffect(() => {


  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, []);



useEffect(() => {
gsap.fromTo('#pic-sec3',
  {scale: 0.5,opacity: 0, },
  {scale: 1, opacity: 1,duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '#pic-sec3',
      start: 'top 80%',
            toggleActions: 'play reverse play reverse',}});

  const animateCount = (id, target) => {
    let current = 0;
    const increment = Math.ceil(target / 60);
    const interval = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(interval);}
      document.getElementById(id).textContent = current + '+';}, 30);};

const observer = new IntersectionObserver(([entry]) => {
  if (entry.isIntersecting) {
    about.forEach((item, index) => {
      animateCount(`num-${index}`, item.number);
    });
  }
}, { threshold: 0.5 });

const target = document.querySelector('.row-sec3');
if (target) observer.observe(target);

  return () => observer.disconnect();
}, [about]);




    return ( 
        <section className='sec2-about'ref={secRef}>
            <section className='container-cards-sec2-about'>
                <section className='big-cont-sec2-about'>
                    <section className='container-sec2--about'>
                    <article className='part1-sec2-about'>

                    <article className='right-text-box-sec2-about'>
                        <h1 className='headerr-sec2-p2'>{content?.[18]?.header}</h1>
                        <article className='left-para-container-sec2-about'>
                            <p className='para-sec2-about'> {content?.[18]?.paragraph}</p>
                             <p className='para-sec2-about'> {content?.[18]?.paragraph2}</p>
                        </article>
                    </article>

                    <div id='pic-sec3' className='pic-sec3-wrapper'>
                    <img  className='pic-sec3' src={content?.[18]?.img} alt={content?.[18]?.img_alt}/>
                    </div>


                    </article>




                    <div className='part2-sec2-about'>
                        <div className='decoration-div-about1'>Discover Tech</div>
                        <div className='decoration-div-about2'>Connect & Network</div>                        
                        <div className='decoration-div-about1'>Modern Offices</div>
                         <div className='decoration-div-about2'>Experience Innovation</div>
                        <div className='decoration-div-about2'>Space Planning</div>                       
                        <div className='decoration-div-about1'>Inspire Design</div>
                        <div className='decoration-div-about2'>Better Environment</div>
                    </div>



</section>
                </section>
            </section>
        </section>
     );
}
 
export default Sec2about;